import React, { useEffect, useRef } from "react";
import "./Explore_By_Category.css";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";
import Explore_Category_Card from "./explore_category_card/Explore_Category_Card";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import "swiper/css";
import "swiper/css/grid";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Autoplay } from "swiper/modules";
import useIsMobile from "./useIsMobile";

const Explore_By_Category = (props) => {
  const navigate = useNavigate();

  const data = [
    {
      img: "/assets/images/home/explore_category/img1.png",
      product: "Vegetables",
    },
    {
      img: "/assets/images/home/explore_category/img2.png",
      product: "Fruits",
    },
    {
      img: "/assets/images/home/explore_category/img3.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img4.png",
      product: "Baby Care",
    },
    {
      img: "/assets/images/home/explore_category/img5.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img6.png",
      product: "Paan Corner",
    },
    {
      img: "/assets/images/home/explore_category/img5.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img6.png",
      product: "Paan Corner",
    },
  ];
  const dispatch = useDispatch();

  const categories = useSelector((state) => state.master.categories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const grouped = [];
  for (let i = 0; i < categories.slice(2).length; i += 2) {
    grouped.push(categories.slice(2).slice(i, i + 2));
  }

  // Ref for horizontal scroll
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 250; // adjust as needed
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // Swiper reference
  const isMobile = useIsMobile();
  return (
    <section className="Explore_By_Category">
      <Common_Heading_Holder headingText={"Explore by Category"} />

      <div className="white_card_div">
        <div className="row">
          <div className="col-xxl-4 col-xl-5 col-lg-6">
            <div className="row me-0 ms-0 justify-content-center">
              <>
                <div
                  className="col-xxl-6 col-xl-6 col-lg-6 col-md-3 col-sm-4 col-6 p-1 mb-2"
                  onClick={() => {
                    props?.setCategoryId(categories[0]?.id);
                  }}
                >
                  <Explore_Category_Card
                    data={categories[0]}
                    id={categories[0]?.id}
                    img={categories[0]?.image}
                    product={categories[0]?.name}
                    goto={"/shop"}
                  />
                </div>
                <div
                  className="col-xxl-6 col-xl-6 col-lg-6 col-md-3 col-sm-4 col-6 p-1 mb-2"
                  onClick={() => {
                    props?.setCategoryId(categories[0]?.id);
                  }}
                >
                  <Explore_Category_Card
                    data={categories[1]}
                    id={categories[1]?.id}
                    img={categories[1]?.image}
                    product={categories[1]?.name}
                  />
                </div>
              </>
            </div>
          </div>

          {/* Swiper Grid for rest categories */}
          <div className="col-xxl-7 col-xl-7 col-lg-6 design_1 category_swiper_holder">
            {/* <div className="navigation_btn_holder">
              <div
                className="btn_holder left_arrow_icon"
                onClick={() => swiperRef.current?.slidePrev()}
              >
                <FontAwesomeIcon icon={faCircleChevronLeft} className="arrow_icon" />
              </div>
              <div
                className="btn_holder right_arrow_icon"
                onClick={() => swiperRef.current?.slideNext()}
              >
                <FontAwesomeIcon icon={faCircleChevronRight} className="arrow_icon" />
              </div>
            </div> */}

            {/* Swiper Grid */}
            {!isMobile && categories?.length > 2 && (
              <Swiper
                modules={[Grid, Autoplay]}
                grid={{ rows: 2, fill: "row" }}
                spaceBetween={10}
                slidesPerView={2}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                // loop
                breakpoints={{
                  485: { slidesPerView: 2 },
                  768: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                }}
                className="categary_grid_slider"
              >
                {categories.slice(2).map((item, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className="grid_view"
                      onClick={() => props.setCategoryId(item.id)}
                    >
                      <Explore_Category_Card
                        data={item}
                        img={item?.image}
                        product={item?.name}
                        id={item?.id}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>

          {/* old design */}

          <div className="col-xxl-7 col-xl-7 col-lg-7 design_2">
            <div className="row me-0 ms-0">
              {categories?.slice(2).map((item, index) => (
                <div
                  key={index}
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 p-1 mb-2 custom_col"
                >
                  <div
                    className="grid_view"
                    onClick={() => {
                      props?.setCategoryId(item?.id);
                    }}
                  >
                    <Explore_Category_Card
                      data={item}
                      img={item?.image}
                      product={item?.name}
                      id={item?.id}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className='col-xxl-4 col-xl-5 col-lg-5'>
                        <div className='row me-0 ms-0 justify-content-center'>
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-3 col-sm-4 col-6 p-1 mb-2'>
                                <Explore_Category_Card img={data[0]?.img} product={data[0]?.product} goto={"/shop"} />
                            </div>
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-3 col-sm-4 col-6 p-1 mb-2'>
                                <Explore_Category_Card img={data[1]?.img} product={data[1]?.product} />
                            </div>
                        </div>
                    </div>
                    <div className='col-xxl-7 col-xl-7 col-lg-7'>
                        <div className='row me-0 ms-0'>

                            {data?.slice(2).map((item, index) => (
                                <div
                                    key={index}
                                    className='col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 p-1 mb-2 custom_col'
                                >
                                    <div className='grid_view'>
                                        <Explore_Category_Card img={item?.img} product={item?.product} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div> */}

          {/* <div className='col-lg-6'>

                        <div className='row me-0 ms-0'>
                            <div className='col-lg-4 p-1'>
                                <Explore_Category_Card img="/assets/images/home/explore_category/img3.png" product="Vegetables" className={"img_holder2"}/>
                            </div>
                            <div className='col-lg-4 p-1'>
                                <Explore_Category_Card img="/assets/images/home/explore_category/img4.png" product="Fruits" className={"img_holder2"}/>
                            </div>
                            <div className='col-lg-4 p-1'>
                                <Explore_Category_Card img="/assets/images/home/explore_category/img5.png" product="Fruits" className={"img_holder2"}/>
                            </div>
                        </div>

                        <div className='row me-0 ms-0'>
                            <div className='col-lg-4 p-1'>
                                <Explore_Category_Card img="/assets/images/home/explore_category/img6.png" product="Vegetables" className={"img_holder2"}/>
                            </div>
                            <div className='col-lg-4 p-1'>
                                <Explore_Category_Card img="/assets/images/home/explore_category/img7.png" product="Fruits" className={"img_holder2"}/>
                            </div>
                            <div className='col-lg-4 p-1'>
                                <Explore_Category_Card img="/assets/images/home/explore_category/img8.png" product="Fruits" className={"img_holder2"}/>
                            </div>
                        </div>

                    </div> */}

          <div className="col-xxl-1 col-xl-12">
            <div
              className="gray_div"
              onClick={() => {
                navigate("/shop");
              }}
            >
              <div className="view_more_div">
                <p className="text">View More</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore_By_Category;
